// User roles matching backend enum exactly
export type UserRole =
  | 'Admin'
  | 'SuperAdmin'
  | 'OperationManager'
  | 'Sales'
  | 'Instructor'
  | 'Mentor'
  | 'Accountant'
  | 'CustomerCare'
  | 'HR'
  | 'Staff'
  | 'SocialMediaManager';

// User status enum matching backend
export type UserStatus = 'active' | 'inactive' | 'pending' | 'suspended';

// Office hours types
export type OfficeHourType = 'PHYSICAL' | 'NON_PHYSICAL' | 'DAY_OFF';

export interface OfficeHour {
  day: string;
  type: OfficeHourType;
  branch?: string | { _id: string; nameEn: string; nameAr: string }; // ObjectId or populated
  startTime?: string;
  endTime?: string;
}

// Role assignment with active status and optional branch
export interface UserRoleAssignment {
  role: UserRole;
  isActive: boolean;
  branchId?: string; // Legacy: For functionality that still uses single branch
  branchIds?: string[]; // For OperationManager/Sales roles
  trackIds?: string[]; // For Mentor/Instructor roles
  isTeamLead?: boolean;
  officeHours?: OfficeHour[]; // For Mentor role
}

// User interface matching backend schema
export interface User {
  id: string;
  _id: string;
  name: string;
  email: string;
  phone?: string;
  profileImage?: string;

  // Employee-specific fields
  dateOfBirth?: string;
  address?: string;
  nationalId?: string;
  nationalIdImage?: string;

  // Account status
  isNew: boolean;

  // Roles (populated from BaseRole)
  roles: UserRoleAssignment[];

  // Permissions outside of roles
  permissions: any[];

  // Timestamps
  lastLogin?: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
}

// Role display info
export const roleInfo: Record<UserRole, { label: string; description: string }> = {
  SuperAdmin: { label: 'roles.superAdmin', description: 'roles.superAdminDesc' },
  Admin: { label: 'roles.admin', description: 'roles.adminDesc' },
  Accountant: { label: 'roles.accountant', description: 'roles.accountantDesc' },
  CustomerCare: {
    label: 'roles.customerCare',
    description: 'roles.customerCareDesc',
  },
  HR: { label: 'roles.hr', description: 'roles.hrDesc' },
  Instructor: { label: 'roles.instructor', description: 'roles.instructorDesc' },
  SocialMediaManager: {
    label: 'roles.socialMedia',
    description: 'roles.socialMediaDesc',
  },
  Mentor: { label: 'roles.mentor', description: 'roles.mentorDesc' },
  OperationManager: {
    label: 'roles.operationManager',
    description: 'roles.operationManagerDesc',
  },
  Sales: { label: 'roles.sales', description: 'roles.salesDesc' },
  Staff: { label: 'roles.staff', description: 'roles.staffDesc' },
};

export * from './user-capabilities';
